/***
 * https://difhub.com/view/organizations/Business%20Systems/systems/Settlement/applications/Billing/datasets/TimeFactor/versions/1
 */
export class TimeFactorDto {
  id?: string;
  component: string; // enum from api
  value: number;

  constructor(d?: TimeFactorDto) {
    if (!d) {
      return;
    }
    this.id = d.id;
    this.component = d.component;
    this.value = d.value;
  }
}
